import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import { PlanResult } from '../../types/PlannerInterfaces';
export interface PlannerInformation {
  plannerInformation: {
    plannerResult: PlanResult | null; //resultado de planificación
    accessibilityFilter: boolean; //filtro accesibilidad
    routeTypeFilter: number; //filtro ruta economica o rapida
    selectedPlan: number; //plan seleccionado
    maxWalkDistance: number | null; //distancia máxima caminando
    order: string; //orden en el que mostrar los itinerarios
    operatorsFilters: Array<number>; //filtros de operadores
  };
}

const initialState: PlannerInformation = {
  plannerInformation: {
    plannerResult: null,
    accessibilityFilter: false,
    routeTypeFilter: 0,
    selectedPlan: 0,
    maxWalkDistance: null,
    order: 'duration',
    operatorsFilters: [],
  },
};

export const plannerSlice = createSlice({
  name: 'plannerSlice',
  initialState,
  reducers: {
    updatePlanResult: (state, action) => {
      state.plannerInformation.plannerResult = action.payload;
    },
    updateAccesibility: (state, action) => {
      state.plannerInformation.accessibilityFilter = action.payload;
    },
    addOperatorsFilters: (state, action) => {
      if (state.plannerInformation.operatorsFilters.indexOf(action.payload as never) < 0)
        state.plannerInformation.operatorsFilters.push(action.payload as never);
    },
    updateOperatorsFilters: (state, action) => {
      state.plannerInformation.operatorsFilters = [...action.payload];
    },
    removeOperatorsFilters: (state, action) => {
      if (state.plannerInformation.operatorsFilters.indexOf(action.payload as never) >= 0)
        state.plannerInformation.operatorsFilters.splice(
          state.plannerInformation.operatorsFilters.indexOf(action.payload as never),
          1,
        );
    },
    updateRouteType: (state, action) => {
      state.plannerInformation.routeTypeFilter = action.payload;
    },
    updateSelectedPlan: (state, action) => {
      state.plannerInformation.selectedPlan = action.payload;
    },
    updateMaxWalkDistance: (state, action) => {
      state.plannerInformation.maxWalkDistance = action.payload;
    },
    updateOrder: (state, action) => {
      state.plannerInformation.order = action.payload;
    },
  },
});

export const { updateOrder, updateAccesibility, updateOperatorsFilters, updateMaxWalkDistance } =
  plannerSlice.actions;

export const plannerInformation = (state: RootState) => state.plannerSlice.plannerInformation;
export const plannerOrderInformation = (state: RootState) =>
  state.plannerSlice.plannerInformation.order;
export const plannerOperatorsInformation = (state: RootState) =>
  state.plannerSlice.plannerInformation.operatorsFilters;
export const plannerAccessibilityInformation = (state: RootState) =>
  state.plannerSlice.plannerInformation.accessibilityFilter;
export const plannerMAxWalkInformation = (state: RootState) =>
  state.plannerSlice.plannerInformation.maxWalkDistance;
